import React from 'react';
import { graphql } from 'gatsby';
import { css } from '@emotion/react';

interface AnchorProps {
    anchor_id?: string
}

const styles = {
    anchor: css({
        height: 0,
    }),
};

const Anchor = (props: AnchorProps): JSX.Element => {
    const { anchor_id } = props;

    return <div css={styles.anchor} id={anchor_id} />;
};

export const query = graphql`
  fragment AnchorData on CmsPageBuilderBlocks {
    anchor {
      anchor_id
    }
  }
`;

export default Anchor;
